<script>
    import { techniques } from "./constants";

    if (!localStorage.currentTechniqueId) {
        localStorage.currentTechniqueId = techniques[0].id;
    }
    let currentTechniqueId = localStorage.currentTechniqueId;

    /**
     * Save current duration and go back to home page
     */
    const onDurationChangedHandler = () => {
        currentTechniqueId = event.currentTarget.value;
        localStorage.currentTechniqueId = currentTechniqueId;
        history.back();
    };
</script>

<style>
    label {
        cursor: pointer;
        display: block;
    }

    @media (min-width: 576px) {
        label {
            max-width: 250px;
            display: inline-block;
        }
    }
</style>

<main class="text-white p-5 text-center">
    {#each techniques as technique}
        <label
            class="mx-2 my-3 py-2 px-3 {currentTechniqueId == technique.id ? 'bg-success text-light' : 'bg-light text-dark'} rounded text-left">
            <div class="font-weight-bold">{technique.pattern.join(' - ')}</div>
            <div>{technique.title}</div>
            <small>{technique.description}</small>
            <input
                type="checkbox"
                value={technique.id}
                class="d-none"
                checked
                on:change={onDurationChangedHandler} /></label>
    {/each}
</main>
